module.exports = "<div class=\"invalid-feedback\"\n     *ngIf=\"isInvalid\"\n     style=\"display: block;\">\n  <ng-content></ng-content>\n</div>"